import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import QuizShell from './components/QuizShell';
import QuestionScreen from './components/QuestionScreen';
import ResultScreen from './components/ResultScreen';
import CountdownScreen from './components/CountdownScreen';
import StartScreen from './components/StartScreen';
import { quizConfig } from './data/quizConfig';
import { trackQuizEvent } from './utils/analytics';
import './App.css';

function App() {
  const [screen, setScreen] = useState('start');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);

  const startQuiz = () => {
    setScreen('quiz');
    trackQuizEvent(quizConfig.analyticsEvents.start);
  };

  const selectAnswer = (answerIndex) => {
    if (selectedAnswer !== null) return;

    const question = quizConfig.questions[currentIndex];
    const correct = answerIndex === question.correctIndex;

    setSelectedAnswer(answerIndex);

    if (correct) {
      setScore((value) => value + 1);
    }

    trackQuizEvent(quizConfig.analyticsEvents.answer, {
      question_id: question.id,
      answer_index: answerIndex,
      correct
    });
  };

  const goNext = () => {
    const question = quizConfig.questions[currentIndex];
    const lastAnswerCorrect = selectedAnswer === question.correctIndex;
    const finalScore = score + (lastAnswerCorrect ? 1 : 0);

    if (currentIndex < quizConfig.questions.length - 1) {
      setCurrentIndex((value) => value + 1);
      setSelectedAnswer(null);
      return;
    }

    setScore(finalScore);
    setScreen('countdown');

    trackQuizEvent(quizConfig.analyticsEvents.complete, {
      score: finalScore,
      total: quizConfig.questions.length
    });
  };

  const restart = () => {
    setCurrentIndex(0);
    setSelectedAnswer(null);
    setScore(0);
    setScreen('start');
  };

  const result = quizConfig.results.find(
    (item) => score >= item.min && score <= item.max
  );

  return (
    <QuizShell screen={screen}>
      <AnimatePresence mode="wait">
        {screen === 'start' && (
          <StartScreen
            key="start"
            config={quizConfig}
            onStart={startQuiz}
          />
        )}

        {screen === 'quiz' && (
          <QuestionScreen
            key={currentIndex}
            question={quizConfig.questions[currentIndex]}
            currentIndex={currentIndex}
            total={quizConfig.questions.length}
            selectedAnswer={selectedAnswer}
            onAnswer={selectAnswer}
            onNext={goNext}
          />
        )}

        {screen === 'countdown' && (
          <CountdownScreen
            key="countdown"
            score={score}
            total={quizConfig.questions.length}
          />
        )}

        {screen === 'result' && result && (
          <ResultScreen
            key="result"
            score={score}
            total={quizConfig.questions.length}
            result={result}
            config={quizConfig}
            onRestart={restart}
            onCtaClick={(cta) => trackQuizEvent(
              quizConfig.analyticsEvents.ctaClick,
              { cta }
            )}
          />
        )}
      </AnimatePresence>
    </QuizShell>
  );
}

export default App;